import axios from 'axios'
import {message} from "ant-design-vue";
import router from '../router';

const instance = axios.create({
  baseURL: 'bada/cityAdmin/mall',
  // baseURL: 'http://192.168.1.254:9091/api/cityAdmin/admin',
  timeout: 20000,
  headers: {'X-Custom-Header': 'MX', project_token: 18111501},
  withCredentials: true,
})

// 请求拦截
instance.interceptors.request.use(
  async config => {
    config.headers.user_token = sessionStorage.getItem('user_token');
    return config
  },
  error => {
    return Promise.reject(error)
  }
);

// 响应拦截
instance.interceptors.response.use(
  response => {
    // 处理响应数据
    console.log(response, 'response')
    let status = Number(response.status);
    if (status === 200) {
      return Promise.resolve(response.data)
    } else if (status === 401 || status === 403) {
      console.log("响应拦截器:", response);
      return Promise.reject(response.data)
    } else if (status === 404) {
      return Promise.reject(response.data)
    } else if (status === 500) {
      return Promise.reject(response.data)
    } else {
      // debugger
      return Promise.reject(response.data)
    }
  }, async err => {
    let resp = err.response;
    let errMsg = resp.data || "服务器错误";
    let status = Number(resp.status);
    message.error(errMsg);
    // 401代表当前的登录已经失效
    if (status === 401) {
      // await router.push("/");
      sessionStorage.clear();
      router.push({name: "login"}).catch(()=>{
        message.warn("跳转到登录页出错");
      });
      return;
    }
    return Promise.reject(err)
  }
)


export default instance




// WEBPACK FOOTER //
// ./src/api/axiosThree.js